import {NICEDialerGeneralSettings} from "./NICE_DialerGeneralSettings.model";
import {NICEDialerDeliverySettings} from "./NICE_DialerDeliverySettings.model";
import {NICEDialerCPASettings} from "./NICE_DialerCPASettings.model";
import {NICEDialerRetrySettings} from "./NICE_DialerRetrySettings.model";
import {NICEDialerListMgmtSettings} from "./NICE_DialerListMgmtSettings.model";
import {NICEDialerScheduleSettings} from "./NICE_DialerScheduleSettings.model";
import {NICEDialerTimezoneSettings} from "./NICE_DialerTimezoneSettings.model";
import {NICEDialerXSSettings} from "./NICE_DialerXSSettings.model";

export class NICEDialerParameters {
    skillName=';'
    skillNo: number;
    generalSettings:NICEDialerGeneralSettings;
    cadenceSettings:any;
    callingLists: any[] = [];
    cpaSettings:NICEDialerCPASettings;
    deliveryPreferences:NICEDialerDeliverySettings;
    filterSettings:any;
    listManagementSettings:NICEDialerListMgmtSettings;
    retrySettings:NICEDialerRetrySettings;
    scheduleSettings:NICEDialerScheduleSettings;
    timeZoneSettings:NICEDialerTimezoneSettings;
    xsSettings:NICEDialerXSSettings;

    constructor(jsonObject?:any,dialerCustomFields?:any) {
        if (jsonObject){
            this.skillName = jsonObject.skillName || '';
            this.skillNo = jsonObject.skillNo ||0;
            this.generalSettings = new NICEDialerGeneralSettings(jsonObject.generalSettings);
            this.cadenceSettings = new NICECadenceSettings(jsonObject.cadenceSettings,dialerCustomFields);
            this.deliveryPreferences = new NICEDialerDeliverySettings(jsonObject.deliveryPreferences);
            this.callingLists = jsonObject.callingLists;
            this.cpaSettings = new NICEDialerCPASettings(jsonObject.cpaSettings);
            this.retrySettings = new NICEDialerRetrySettings(jsonObject.retrySettings);
            this.filterSettings = jsonObject.filterSettings;
            this.listManagementSettings = new NICEDialerListMgmtSettings(jsonObject.listManagementSettings);
            this.scheduleSettings = new NICEDialerScheduleSettings(jsonObject.scheduleSettings);
            this.xsSettings = new NICEDialerXSSettings(jsonObject.xsSettings);
            this.timeZoneSettings = new NICEDialerTimezoneSettings(jsonObject.timeZoneSettings);
        }
    }
}

export class NICECadenceSettings {
    attemptMode: string;
    recordRequestMode: string;
    destinationRetryRestMinutes: number;
    maximumAttempts: {"fieldName": string, "attempts": number }[] = [];
    cadences: {fieldName: string, attempts: number, timeConstraints: any} [] = [];
    constructor(jsonObject?:any,dialerCustomFields?:any) {
        this.attemptMode = jsonObject.attemptMode.toString();
        this.recordRequestMode = jsonObject.recordRequestMode.toString();
        this.destinationRetryRestMinutes = jsonObject.destinationRetryRestMinutes || 0;
        for (let i = 0; i < jsonObject.cadenceMaximumAttempts.length; i++) {
            this.maximumAttempts.push({
                fieldName: jsonObject.cadenceMaximumAttempts[i].label,
                attempts: jsonObject.cadenceMaximumAttempts[i].maxAttempts
            });
        }

        // Add default fields and attempts for missing records in dialerCustomFields
        if (dialerCustomFields && Array.isArray(dialerCustomFields)) {
            const existingFields = this.maximumAttempts.map(entry => entry.fieldName);
            dialerCustomFields.push({Name:"SmsPhoneNumber",IsDestinationField:true});
            for (const customField of dialerCustomFields) {
                if (!existingFields.includes(customField.Name) && customField.IsDestinationField) {
                    this.maximumAttempts.push({
                        fieldName: customField.Name,
                        attempts: 0 // Default attempts value, can be changed if needed
                    });
                }
            }
        }


        for (let i = 0; i < jsonObject.cadences.length; i++) {
            const cadence = {
                fieldName: jsonObject.cadences[i].fieldName,
                attempts: jsonObject.cadences[i].attempts,
                timeConstraints: processTimeConstraints(jsonObject.cadences[i].timeConstraints)
            };
            this.cadences.push(cadence);
        }
    }
}

function processTimeConstraints(timeConstraints: any[]): {
    weekdayTimeConstraints: { startTime: string, endTime: string }[],
    weekendTimeConstraints: { startTime: string, endTime: string }[]
} {
    const processedConstraints = {
        weekdayTimeConstraints: [],
        weekendTimeConstraints: []
    };

    for (const constraint of timeConstraints) {
        if (constraint.dayType === "Weekday") {
            processedConstraints.weekdayTimeConstraints.push({
                startTime: constraint.startTime,
                endTime: constraint.endTime
            });
        } else if (constraint.dayType === "Weekend") {
            processedConstraints.weekendTimeConstraints.push({
                startTime: constraint.startTime,
                endTime: constraint.endTime
            });
        }
    }

    return processedConstraints;
}

